// src/components/ResultQuiz.jsx
import React from "react";
import "./ResultQuiz.scss";
import UserResultPage from "./UserResultPage";
import AdminResultPage from "./AdminResultPage";

const ResultQuiz = ({ userdata, isAdmin, adminData }) => {
  return (
    <div className="result-container-1">
      {isAdmin ? (
        <AdminResultPage adminData={adminData} />
      ) : (
        <UserResultPage userdata={userdata} />
      )}
    </div>
  );
};

export default ResultQuiz;
